import { render } from "./AuthWindow.vue?vue&type=template&id=32912518&scoped=true"
import script from "./AuthWindow.vue?vue&type=script&lang=js"
export * from "./AuthWindow.vue?vue&type=script&lang=js"

import "./authWindow.css?vue&type=style&index=0&id=32912518&scoped=true&lang=css"

import exportComponent from "/home/node/site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32912518"]])

export default __exports__